import request from '@utils/request'
import { ParamsProps, ReturnType } from './types'

const list = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: 'notifications/admins',
      method: 'get',
      authorization: true,
      params: args?.params,
      config: {
        showErr: true,
        store: {
          key: args?.state,
          action: 'set',
        },
      },
    }
    const response = await request(config)
    return response
  } catch (err: any) {
    throw new Error(err)
  }
}
const markAsRead = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: `notifications/admins/read/${args?.id}`,
      method: 'patch',
      authorization: true,
      config: {
        showErr: true,
        store: {
          key: args?.state,
          action: 'update',
        },
      },
    }
    const response = await request(config)
    return response
  } catch (err: any) {
    throw new Error(err)
  }
}

export default { list, markAsRead }
